import {getEnv} from '../../common/env/env';
import {GetSingleResultVo} from '../../common/shared/api/nicolas/vo/GetSingleResultVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {ReadAccessType, SinglePreview} from '../generated/types';
import {createLocaleType} from './LocaleType';
import {createReadAccessType} from './ReadAccessType';
import {createSaleState} from './SaleState';
import {createSlideType} from './SlideType.enum';

export function createSinglePreview({
  series_authorName,
  series_description,
  series_landThumbnailUrl,
  series_thumbnailUrl,
  series_title,
  read_access_type,
  single: {
    series_id,
    product_id,
    category_uid,
    state,
    title,
    author,
    slide_type,
    thumbnail_url,
    land_thumbnail_url,
    free,
  },
  series_lang,
}: GetSingleResultVo): SinglePreview {
  return {
    seriesId: series_id,
    productId: product_id,
    seriesLang: createLocaleType(series_lang),
    title,
    author,
    categoryUid: category_uid,
    slideType: createSlideType(slide_type),
    saleState: createSaleState(state),
    isFree: free,
    thumbnail: thumbnail_url.startsWith('http')
      ? thumbnail_url
      : getKageUrl({
          kageUrlPrefix: getEnv().kageUrlPrefix,
          kageId: thumbnail_url,
          resolution: 'th3',
        }),
    landThumbnail: land_thumbnail_url
      ? land_thumbnail_url.startsWith('http')
        ? land_thumbnail_url
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: land_thumbnail_url,
            resolution: 'th3',
          })
      : undefined,
    readAccessType: read_access_type
      ? createReadAccessType(read_access_type)
      : ReadAccessType.NotPurchased,
    seriesPreview: {
      title: series_title,
      author: series_authorName,
      description: series_description,
      landThumbnail: series_landThumbnailUrl
        ? series_landThumbnailUrl.startsWith('http')
          ? series_landThumbnailUrl
          : getKageUrl({
              kageUrlPrefix: getEnv().kageUrlPrefix,
              kageId: series_landThumbnailUrl,
              resolution: 'th3',
            })
        : undefined,
      thumbnail: series_thumbnailUrl
        ? series_thumbnailUrl.startsWith('http')
          ? series_thumbnailUrl
          : getKageUrl({
              kageUrlPrefix: getEnv().kageUrlPrefix,
              kageId: series_thumbnailUrl,
              resolution: 'th3',
            })
        : undefined,
    },
  };
}
